/**
 * @file   src\components\Tutorial\AgentDashboardModal.js
 * @brief  This file is responsible for agent dashboard tutorial in web view
 * @date   May, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import Modal from "react-bootstrap/Modal";
import { Button } from "react-bootstrap";
import DbPopupImg from "../../images/dashboard-popup-img.png";

const AgentDashboardModal = (props) => {
  const { handleConfirm, onHide } = props;

  return (
    <Modal
      show
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-width-548"
    >
      <Modal.Body className="pt-32 pb-32">
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={() => {
            onHide();
          }}
        ></button>
        <h3 className="text-center">
          Use your agent dashboard to organize and manage your client's
          properties
        </h3>
        <p className="f-size-16 text-center mb-32">
          We're here to help make your job easier - and that starts with giving
          you some tools to keep you organized!
        </p>

        <img className="inner-disp-img mb-32" src={DbPopupImg} />

        <Button
          variant="primary"
          className="btn w-100"
          onClick={() => {
            handleConfirm();
          }}
        >
          Take a look
        </Button>

        <Button
          variant=""
          className="w-100 l-spacing-0 btn-no-bg mt-3"
          onClick={() => {
            onHide();
          }}
        >
          Skip tutorial
        </Button>
      </Modal.Body>
    </Modal>
  );
};
export default AgentDashboardModal;
